import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubmissionStatusAction } from '../actionCreators';

const hasRegisteredSubmissionStatusHandler = (registeredEventHandlers) =>
  registeredEventHandlers.indexOf('submissionStatusUpdated') !== -1;

const useSubmissionStatus = () => {
  const dispatch = useDispatch();

  const { id, token } = useSelector((store) => store.submission);

  const { iFrameId, registeredEventHandlers } = useSelector(
    (store) => store.optionalFormConfig
  );

  useEffect(() => {
    if (
      !id ||
      !token ||
      !hasRegisteredSubmissionStatusHandler(registeredEventHandlers)
    ) {
      return;
    }

    dispatch(
      getSubmissionStatusAction({
        iFrameId,
        submissionId: id,
        token,
      })
    );
  }, [id, token]);
};

export default useSubmissionStatus;
